import React from 'react';
import Footer from '../../components/Footer';
import SubFooter from '../../components/SubFooter';
import Img from "../../assets/maya.jpg";
import HighestImg from "../../assets/courses/highest.gif";
import AvgImg from "../../assets/courses/avg.png";
import YearImg from "../../assets/courses/year.gif";
import vp from "../../assets/aboutus/vp.png";

const stats = [
    { id: 1, name: 'Highest Package', value: '43.5 Lakh', image: HighestImg },
    { id: 2, name: 'Average Package', value: '5.48 Lakh', image: AvgImg },
    { id: 3, name: 'Years of Legacy', value: '14', image: YearImg },
];

const Vp_msg = () => {
    return (
        <div className="w-full relative bg-gradient-to-b from-white to-gray-50">
            <h2 className="text-center text-3xl md:text-5xl font-extrabold mt-24 md:mt-36 text-[#0e4d38]">
                Vice President’s Message
            </h2>

            {/* Top Section */}
            <div className="w-10/12 mx-auto flex flex-col md:flex-row items-center justify-between gap-12 mt-16">
                <img
                    src={vp}
                    alt="President"
                    className="rounded-xl shadow-lg w-full md:w-1/3 object-cover"
                />
                <div className="space-y-4 md:w-2/3 text-center md:text-left border border-gray-300 rounded-lg p-6 shadow-md bg-white">
                    <h1 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">

                        Dr. Tripti Juyal Semwal
                    </h1>
                    <p className="text-md text-gray-600">Vice President</p>
                    <blockquote className="italic text-lg text-[#0e4d38] bg-gray-100 p-4 rounded-lg shadow-sm border-l-4 border-[#0e4d38]">
                        "Everyone can rise above their circumstances and achieve success if they are dedicated to and passionate about what they do." – Mother Teresa
                    </blockquote>
                </div>

            </div>

            {/* Message Section */}
            <div className="w-10/12 mx-auto mt-16 flex flex-col-reverse md:flex-row items-center gap-12">
            
                <p className="text-justify text-gray-700 text-md leading-relaxed md:w-2/3">
                <h6>Vice President’s Message<br /><br /></h6>
                    I am grateful and thankful to divine and Shri. Manohar Lal Juyal (President Maya Devi University) for giving me an opportunity to serve as the first Vice President of Maya Devi University.<br />
                    <br />


                    The faculty members and staff serve this unique University with a great dedication because they care about students, and are here to serve you to consider your principle, and to grow you on a path to your professional goals. On behalf of the Maya family and faculty members, staff, students and alumni, I humbly welcome everyone to our awesome community, where we embrace our mission and celebrate our dedication to equipping students to honour God in their personal, professional, cultural and spiritual lives.<br />
                    <br />


                    At Maya Devi University you will learn to think broadly and experience a cultural, thoughtful and caring environment. If you want to extend your spiritual core, develop your potential, and engage in today’s intricate issues.<br /><br />



                    We feel great pride and joy in the diversity of our community in every aspect; we must maintain the work of building a new diverse and inclusive community across the University. Our success requires thoughtfulness and respect in every interface on our campus. Each of us has a role to play in helping to guarantee access and inclusion for all members of our community.<br /><br />



                    We are delighted that you have preferred to become a part of the Maya Devi University. On behalf of our faculty and staff, I wish you every success as you pursue your educational endeavors.<br />


                    Come for a University’s Campus visit – you’ll see what I mean. Then come and join – your professional life will be transformed in ways you can only envision. Wherever you are in your educational journey – we welcome you!<br /><br />



                    <span className="font-bold">
                        Dr. Tripti Juyal Semwal<br />

                        Vice President
                    </span>
                </p>
                <img
                    src={Img}
                    alt="Maya Devi University Logo"
                    className="rounded-xl shadow-lg w-full md:w-1/3 object-cover"
                />
            </div>

            {/* Footer */}
            <SubFooter />
            <Footer />
        </div>
    );
};

export default Vp_msg;
